import { IRequestForm } from '../../types/requestForm';
import { createNoopReducer } from '../../utils/redux/createNoopReducer';

export const INITIAL_STATE: IRequestForm = {
  showRequestForm: false,
};

export const requestFormReducer = createNoopReducer<IRequestForm>(INITIAL_STATE);
